import axios from "axios";

export default {
  data() {
    return {
      apiUrl: this.mfConfig?.api,
      tenantId: this.realm,
      versions: [],
      latestVersion: {},
      mashup: {},
      urlPath: "",
      mashupId: "",
      mashupVersion: "",
      versionId: "",
      createVersionId: "",
      versionName: "",
      dialogSelectVersion: false,
      actionSelectVersion: "",
      projectVersions: [],
      selectedVersion: null,
      currentVersion: null,
    };
  },
  mounted() {
    this.urlPath = window.location.pathname;
    this.mashupId = this.urlPath.split("draw/").pop().split("/v")[0];
    this.mashupVersion = this.urlPath.split("v/").pop().split("/edit")[0];
    this.getMashup();
    this.getVersions();
  },
  methods: {
    //Get Mashup info
    getMashup() {
      axios
        .get(
          this.apiUrl + "/" + this.tenantId + "/projects/" + this.mashupId,
          this.opts,
        )
        .then((response) => {
          this.mashup = response.data;
          this.editedItem = JSON.parse(JSON.stringify(response.data));
        })
        .catch((err) => {
          this.setError(err, false);
        });
    },
    //Get Current Version ID from URL
    getCurrentVersionId() {
      return window.location.pathname.split("/v/")[1].split("/")[0];
    },
    //Find a version by ID
    findVersion(id) {
      return this.versions.find((version) => {
        return version._id === id;
      });
    },
    //Get mashup versions
    getVersions() {
      this.toggleOverlay(true);
      axios
        .get(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.mashupId +
            "/versions",
          this.opts,
        )
        .then((response) => {
          this.versions = response.data;
          let urlVersionId = this.getCurrentVersionId();
          this.currentVersion = this.findVersion(urlVersionId);
          this.latestVersion = this.versions[this.versions.length - 1];
          this.versionName = this.currentVersion.name;
          this.isVersionReleased = this.currentVersion.released;
          this.createVersionId = this.latestVersion._id;
          this.versionId = this.currentVersion._id;
          this.toggleOverlay(false);
        })
        .catch((err) => {
          this.toggleOverlay(false);
          this.setError(err, false);
        });
    },
    //create versions
    closeCreateVersion() {
      this.dialogCreateVersion = false;
      this.$refs.createForm.resetValidation();
      this.editedVersionName = "";
    },
    createVersion(name) {
      if (this.validateCreateForm()) {
        axios
          .post(
            this.apiUrl +
              "/" +
              this.tenantId +
              "/projects/" +
              this.mashup._id +
              "/versions/" +
              this.createVersionId +
              "/duplicate",
            { name: name },
            this.opts,
          )
          .then((response) => {
            let newVersion = response.data;
            this.snackbarColor = "green";
            this.snackbarText = this.$t("strings.create-version-mashup-text");
            this.snackbar = true;
            this.getVersions();

            this.$router
              .push({
                path:
                  `/` +
                  this.realm +
                  `/draw/` +
                  newVersion.project +
                  `/v/` +
                  newVersion._id +
                  `/edit`,
              })
              .then(() => {
                this.reloadEditorContent();
                this.closeCreateVersion();
              })
              .catch((error) => {
                console.error("Navigation error:", error);
              });
          })
          .catch((err) => {
            this.setError(err, false);
          });
      }
    },
    deleteVersionConfirm() {
      axios
        .delete(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.mashup._id +
            "/versions/" +
            this.version._id,
          this.opts,
        )
        .then(() => {
          this.snackbarColor = "green";
          this.snackbarText = this.$t("labels.delete-version-snackbar-text");
          this.snackbar = true;
          this.dialogVersionDelete = false;
          this.getVersions();
          let urlVersionId = this.getCurrentVersionId();
          if (urlVersionId === this.version._id && this.versions.length > 0) {
            this.selectVersionId(this.versions[0]._id);
          }
        })
        .catch((err) => {
          this.setError(err, false, "");
        });
    },
    //release versions
    releaseVersion() {
      this.dialogRelease = true;
    },
    closeReleaseVersion() {
      this.dialogRelease = false;
    },
    //Confirm release version after validation
    releaseVersionConfirm() {
      // Define callback function
      const releaseConfirmHandler = async (event) => {
        this.dialogRelease = false;
        //Remove the event listener
        document.removeEventListener(
          "release-valid-mashup",
          releaseConfirmHandler,
        );

        if (event.detail.result) {
          //Releases the mashup
          await this.releaseConfirm();
          document.dispatchEvent(new CustomEvent("refresh-mashup-version"));
        } else {
          this.snackbarText = this.$t("strings.resolve-mashup-issues");
          this.snackbarColor = "red";
          this.snackbar = true;
        }
      };
      // Aggiungi l'event listener
      document.addEventListener("release-valid-mashup", releaseConfirmHandler);
      // Chiama validate(apiDraw, validateData) in VueFlowEditor.js
      document.dispatchEvent(new CustomEvent("validate-mashup"));
    },

    async releaseConfirm() {
      let configs = { ...this.opts };
      if (!configs.params) {
        configs.params = {};
      }
      configs.params.alsoNestedVersions = true;

      axios
        .patch(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.mashupId +
            "/versions/" +
            this.versionId +
            "/release",
          {},
          configs,
        )
        .then(() => {
          this.snackbarText =
            this.$t("labels.release-version-snackbar-text") +
            ": " +
            this.versionName;
          this.snackbarColor = "green";
          this.snackbar = true;
          this.dialogRelease = false;
          this.getVersions();
          this.dialogCreateVersion = true;
        })
        .catch((err) => {
          this.setError(err, false);
          this.dialogRelease = false;
        });
    },

    //DUPLICATE && EXPORT
    //Select version mashup
    selectMashupVersion(action) {
      this.overlay = true;
      //Assign current version as default
      this.selectedVersion = this.findVersion(this.getCurrentVersionId());
      this.actionSelectVersion = action;
      this.dialogSelectVersion = true;
    },
    //Confirm Duplicate or Export action
    versionMashupConfirm() {
      this.actionSelectVersion === "duplicate"
        ? this.duplicateMashup(this.editedItem.title)
        : this.exportMashup(this.editedItem.title);
      this.closeSelectVersion();
    },
    //Duplicate a Mashup
    duplicateMashup(name) {
      axios
        .post(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.editedItem._id +
            "/duplicate",
          {
            versionId: this.selectedVersion._id,
            title: name,
          },
          this.opts,
        )
        .then(() => {
          this.snackbarColor = "green";
          this.snackbarText = this.$t("strings.duplicate-mashup-text");
          this.snackbar = true;
        })
        .catch((err) => {
          this.setError(err, false);
          this.overlay = false;
        });
    },
    //Exports a Mashup
    exportMashup(title) {
      axios
        .get(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.editedItem._id +
            "/versions/" +
            this.selectedVersion._id +
            "/export",
          this.opts,
        )
        .then((response) => {
          this.downloadMashup(response.data, title);
          this.editedItem = Object.assign({}, this.defaultItem);
          this.overlay = false;
        })
        .catch((err) => {
          this.setError(err, false);
          this.overlay = false;
        });
    },
    //Downloads exported Mashup
    downloadMashup(exportObj, exportName) {
      let fileURL = window.URL.createObjectURL(
        new Blob([JSON.stringify(exportObj)]),
        {
          type: "application/json",
        },
      );
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", exportName + ".json");
      fileLink.click();
      fileLink.remove();
    },
    //Closes Duplicate/Export modal and resets
    closeSelectVersion() {
      this.dialogSelectVersion = false;
      this.overlay = false;
      this.editedItem = Object.assign({}, this.mashup);
    },

    //Delete the mashup
    deleteMashup() {
      this.dialogDelete = true;
    },
    deleteMashupConfirm() {
      axios
        .delete(
          this.apiUrl + "/" + this.tenantId + "/projects/" + this.mashupId,
          this.opts,
        )
        .then(() => {
          this.$router.push("/mashups");
        })
        .catch((err) => {
          this.setError(err, false);
        });
      this.closeDeleteMashup();
    },
    closeDeleteMashup() {
      this.dialogDelete = false;
    },
    closeDeleteVersion() {
      this.dialogVersionDelete = false;
    },
    validateCreateForm() {
      return this.$refs.createForm.validate();
    },
    //Send an event to trigger an overlay
    //in the mashup-editor section of the page
    toggleOverlay(released) {
      document.dispatchEvent(
        new CustomEvent("toggle-overlay", {
          detail: {
            released: released,
          },
        }),
      );
    },
  },
};
